module.exports = __webpack_public_path__ + "img/ring_g_skip_1_0@3x.44a643b7.png";